export function getBrowserLanguage() {
  const locale = navigator.language.toLowerCase().substr(0, 2);
  // 'en' as fallback if language not in list
  return ['en', 'de', 'it', 'es'].indexOf(locale) === -1 ? 'en' : locale;
}
